/* eslint-disable */
import saveStoreDraft from "../../../utils/saveStoreDraft";
import useStoreFormDraft from "../../../hooks/useStoreFormDraft";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { applyStoreDraft } from "../../../redux/store/store";
import { doc, updateDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../../firebase";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import {
  MessageCircle,
  Check,
  X,
  RefreshCw,
  Info,
  Trash2,
  Plus,
  Calendar,
  ExternalLink,
  Sparkles,
  Crown,
  Zap,
  Settings,
  Gift,
} from "lucide-react";
import { useTranslation } from "react-i18next";
// import { Link } from "react-router-dom";

export default function ActivationFoorchat({ close }) {
  const account = useSelector((state) => state.AccountReducer);
  const store = useSelector((state) => state.StoreReducer);
  const products = useSelector((state) => state.ProductsReducer);
  const dispatch = useDispatch();
  const MySwal = withReactContent(Swal);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useStoreFormDraft(store);
  const [initialState, setInitialState] = useState(store);
  const [changed, setChanged] = useState(false);

  const showAlert = (icon, title, text) => {
    return Swal.fire({
      icon,
      title,
      text,
      confirmButtonText: t("servicePageActivation.foorchat.alerts.okButton"),
      confirmButtonColor: "rgb(147, 51, 234)",
      backdrop: `rgba(0,0,0,0.8)`,
      position: "center",
      customClass: {
        popup: "rounded-2xl",
        confirmButton: "rounded-xl px-8 py-3",
      },
    });
  };

  useEffect(() => {
    if (store) {

      setInitialState(store);
      setChanged(false);
    }
  }, [store]);

  const hasStateChanged = () => {
    return (
      changed ||
      JSON.stringify(data.foorchat) !== JSON.stringify(initialState.foorchat)
    );
  };

  const toggleFeature = () => {
    setData({
      ...data,
      foorchat: {
        ...data.foorchat,
        enabled: !data?.foorchat?.enabled,
      },
    });
    setChanged(true);
  };

  // دالة إضافة الرصيد المجاني للمرة الأولى
  const addInitialBalance = async () => {
    try {
      // التحقق من وجود foorchatSolde في الحساب
      const hasExistingBalance = account?.foorchatSolde?.solde !== undefined;

      if (!hasExistingBalance) {
        // إضافة 5 دولار كرصيد مجاني للمرة الأولى
        const accountRef = doc(db, "account", account.id);

        await updateDoc(accountRef, {
          "foorchatSolde.solde": 5.0,
          "foorchatSolde.lastUsed": serverTimestamp(),
          "foorchatSolde.initialBalanceAdded": true, // للتأكد من عدم الإضافة مرة أخرى
          "foorchatSolde.initialBalanceDate": serverTimestamp(),
        });

        // إظهار رسالة ترحيب بالرصيد المجاني
        await Swal.fire({
          icon: "success",
          title: t("foorchat.link_pages.welcome.title"),
          html: t("foorchat.link_pages.welcome.html"),
          confirmButtonText: t("foorchat.link_pages.welcome.confirmButton"),
          confirmButtonColor: "rgb(147, 51, 234)",
          customClass: {
            popup: "rounded-2xl",
            confirmButton: "rounded-xl px-8 py-3",
          },
        });
      }
    } catch (error) {
      console.error("Error adding initial balance:", error);
      // لا نظهر رسالة خطأ هنا لعدم إزعاج المستخدم
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!hasStateChanged()) {
      await showAlert(
        "info",
        t("servicePageActivation.foorchat.alerts.noChangesTitle"),
        t("servicePageActivation.foorchat.alerts.noChangesText"),
      );
      return;
    }

    try {
      setLoading(true);

      // حفظ إعدادات المتجر
      await saveStoreDraft(doc(db, "store", data.id), store, data);
      dispatch(applyStoreDraft(store, data));

      // إذا تم تفعيل الخدمة لأول مرة، إضافة الرصيد المجاني
      if (data?.foorchat?.enabled && !initialState?.foorchat?.enabled) {
        await addInitialBalance();
      }

      setLoading(false);
      setInitialState({ ...data });
      setChanged(false);

      await showAlert(
        "success",
        t("servicePageActivation.foorchat.alerts.saveSuccess"),
        "",
      );
      close();
    } catch (error) {
      setLoading(false);
      await showAlert(
        "error",
        t("servicePageActivation.foorchat.alerts.errorTitle"),
        t("servicePageActivation.foorchat.alerts.errorText"),
      );
    }
  };

  const updatePage = (index, field, value) => {
    const updatedPages = [...data.foorchat?.page];
    updatedPages[index][field] = value;
    if (field === "mode" && value === "pageId") {
      updatedPages[index].urlProduct = "";
    }
    setData({
      ...data,
      foorchat: { ...data.foorchat, page: updatedPages },
    });
    setChanged(true);
  };

  const removePage = (index) => {
    const updatedPages = [...data.foorchat?.page];
    const removedPageId = updatedPages[index].pageId;
    updatedPages.splice(index, 1);

    const updatedIds = (data.foorchatPageId || []).filter(
      (id) => id !== removedPageId,
    );

    setData({
      ...data,
      foorchat: { ...data.foorchat, page: updatedPages },
      foorchatPageId: updatedIds,
    });
    setChanged(true);
  };

  if (account?.subscription?.plan !== "الأسطورية") {
    return (
      <div className="min-h-[500px] bg-gradient-to-br from-gray-50 via-white to-purple-50 dark:from-[#1a1a1a] dark:via-[#141414] dark:to-[#1e1e2e] rounded-3xl shadow-2xl">
        <div className="flex flex-col items-center justify-center h-full py-20 px-8 text-center">
          {/* Icone */}
          <div className="relative mb-8">
            <div className="w-24 h-24 bg-gradient-to-r from-purple-600 to-[#8d5da7] rounded-full flex items-center justify-center mb-4 mx-auto shadow-2xl">
              <Crown className="w-12 h-12 text-white" />
            </div>
            <div className="absolute -top-2 -right-2 w-8 h-8 bg-yellow-500 rounded-full flex items-center justify-center shadow-lg">
              <Sparkles className="w-4 h-4 text-white" />
            </div>
          </div>

          {/* Texte principal */}
          <div className="space-y-4 mb-8">
            <h2 className="text-3xl font-bold bg-gradient-to-r from-purple-600 to-[#8d5da7] dark:from-purple-400 dark:to-[#a678c5] bg-clip-text text-transparent">
              {t("servicePageActivation.foorchat.notEligible.title")}
            </h2>
            <p className="text-xl font-semibold text-gray-700 dark:text-gray-300">
              {t("servicePageActivation.foorchat.notEligible.subtitle")}
            </p>

            {/* Bloc description */}
            <div className="bg-white/80 dark:bg-[#1f1f1f]/80 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-purple-100 dark:border-[#3c3a3d]">
              <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
                {t("servicePageActivation.foorchat.notEligible.description")}
              </p>
            </div>
          </div>

          {/* Bouton upgrade */}
          <a
            href="/plan"
            className="group relative inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white bg-gradient-to-r from-purple-600 to-[#8d5da7] rounded-2xl shadow-2xl hover:shadow-purple-500/25 hover:scale-105 transform transition-all duration-300 overflow-hidden"
          >
            <div className="absolute inset-0 bg-gradient-to-r from-purple-700 to-blue-700 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            <Zap className="w-5 h-5 ml-3 relative z-10" />
            <span className="relative z-10">
              {t("servicePageActivation.foorchat.notEligible.upgradeButton")}
            </span>
            <div className="absolute inset-0 bg-white/10 transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="">
      <div className="">
        {/* Header Section */}
        <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-4 m-3 mt-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center space-x-reverse space-x-4">
              <div className="w-12 h-12 bg-gradient-to-r from-purple-500 to-[#8d5da7] rounded-xl flex items-center justify-center shadow-lg">
                <MessageCircle className="w-6 h-6 text-white" />
              </div>
              <div>
                <h3 className="text-2xl font-bold bg-gradient-to-r from-purple-600 to-[#8d5da7] bg-clip-text text-transparent">
                  {t("servicePageActivation.foorchat.header.title")}
                </h3>
                <p className="text-gray-600 dark:text-gray-400 text-sm">
                  {t("servicePageActivation.foorchat.header.subtitle")}
                </p>
              </div>
            </div>

            <div className="flex items-center space-x-reverse space-x-3">
              <div
                onClick={toggleFeature}
                className={`px-4 py-2 rounded-full text-sm font-semibold shadow-lg cursor-pointer transition-colors duration-200 ${
                  data?.foorchat?.enabled
                    ? "bg-gradient-to-r from-green-500 to-emerald-500 text-white"
                    : "bg-gradient-to-r from-gray-400 to-gray-500 text-white"
                }`}
              >
                {data?.foorchat?.enabled
                  ? t("servicePageActivation.foorchat.header.toggle.enabled")
                  : t("servicePageActivation.foorchat.header.toggle.disabled")}
              </div>
            </div>
          </div>

          <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
            {t("servicePageActivation.foorchat.header.description")}
          </p>

          {/* إضافة معلومة عن الرصيد المجاني للمرة الأولى */}
          {!data?.foorchat?.enabled &&
            !account?.foorchatSolde?.initialBalanceAdded && (
              <div className="mt-4 bg-gradient-to-r from-purple-50 to-pink-50 border border-purple-200 rounded-lg p-4">
                <div className="flex items-center space-x-reverse space-x-3">
                  <div className="w-8 h-8 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center">
                    <Gift className="w-4 h-4 text-white" />
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-purple-800 mb-1">
                      {t("foorchat.link_pages.firstTimeOffer.title")}
                    </h4>
                    <p className="text-xs text-purple-600">
                      {t("foorchat.link_pages.firstTimeOffer.description")}
                    </p>
                  </div>
                </div>
              </div>
            )}
        </div>

        <form onSubmit={handleSubmit} className="space-y-8">
          {/* Toggle Section */}
          <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-4 m-3 mt-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
            <div className="flex justify-between items-center mb-4">
              <label className="text-lg font-semibold text-gray-800 dark:text-gray-200">
                {t("servicePageActivation.foorchat.form.addPageLabel")}{" "}
              </label>
            </div>

            <div className="bg-gray-50 dark:bg-gray-800 rounded-xl p-4 border-2 border-dashed border-gray-200 dark:!border-gray-600 hover:border-purple-300 dark:hover:border-purple-500 transition-colors duration-300 ">
              <iframe
                className="w-full h-48 rounded-lg cursor-pointer transition-shadow duration-300"
                src="https://chatbot-1-16m1.onrender.com/"
                title={t("servicePageActivation.foorchat.form.previewTitle")}
                frameBorder="0"
              />
            </div>
          </div>

          {/* Pages Section */}
          {data.foorchat?.page && data.foorchat?.page.length > 0 && (
            <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-4 m-3 mt-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
              <div className="space-y-4 ">
                {data.foorchat?.page.map((page, index) => (
                  <div
                    key={page.pageId}
                    className="relative bg-gradient-to-r from-gray-50 to-purple-50 dark:from-gray-800 dark:to-gray-900 rounded-xl p-6 border border-gray-200 dark:!border-gray-600 hover:border-purple-300 dark:hover:border-purple-500 transition-all duration-300 hover:shadow-md"
                  >
                    <button
                      type="button"
                      onClick={() => removePage(index)}
                      className="absolute top-4 left-4 p-2 text-red-500 hover:text-red-700 hover:bg-red-50 dark:hover:bg-red-900 rounded-lg transition-colors duration-200"
                    >
                      <Trash2 size={16} />
                    </button>

                    <div className="mb-4 pl-10">
                      <div className="font-semibold text-gray-800 dark:text-gray-200 text-lg mb-1">
                        {page.name}
                      </div>
                      <div className="text-xs text-gray-500 dark:text-gray-400 bg-gray-100 dark:bg-gray-700 px-3 py-1 rounded-full inline-block">
                        {t("servicePageActivation.foorchat.form.pageid")}{" "}
                        {page.pageId}
                      </div>
                    </div>
                    {/* ----------------------------------------------------------------------------------------------- */}
                    <div className=" mx-auto ">
                      <ul className="mt-6 space-y-3">
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                          <li>
                            <label className="block relative">
                              <input
                                type="radio"
                                name={`mode-${page.pageId}`}
                                checked={page.mode === "pageId"}
                                onChange={() =>
                                  updatePage(index, "mode", "pageId")
                                }
                                className="sr-only peer"
                              />
                              <div className="w-full flex gap-x-3 items-start p-4 cursor-pointer rounded-lg border bg-white shadow-sm ring-indigo-600 peer-checked:ring-2 duration-200">
                                <div className="flex-none">
                                  <img
                                    src="https://cdn-icons-png.flaticon.com/128/4712/4712029.png" // رابط الـ GIF
                                    style={{ width: "28px" }} // حجم صغير داخل الزر
                                    alt={t("ui.buttonIcon")}
                                  />
                                </div>
                                <div>
                                  <h3 className="leading-none text-gray-800 font-medium pr-3">
                                    {t(
                                      "servicePageActivation.foorchat.form.pageIdMode",
                                    )}
                                  </h3>
                                  <p className="mt-1 text-sm text-gray-600">
                                    {t(
                                      "servicePageActivation.foorchat.form.pageIdMode1",
                                    )}
                                  </p>
                                </div>
                              </div>
                              <div className="absolute top-4 left-4 flex-none flex items-center justify-center ww-4 hh-4 rounded-full border peer-checked:bg-indigo-600 text-white peer-checked:text-white duration-200">
                                <svg className="w-4 h-4" viewBox="0 0 12 10">
                                  <polyline
                                    fill="none"
                                    strokeWidth="2px"
                                    stroke="currentColor"
                                    strokeDasharray="16px"
                                    points="1.5 6 4.5 9 10.5 1"
                                  />
                                </svg>
                              </div>
                            </label>
                          </li>

                          {/* Master Card (محددة افتراضيًا) */}
                          <li>
                            <label className="block relative">
                              <input
                                type="radio"
                                name={`mode-${page.pageId}`}
                                checked={page.mode === "product"}
                                onChange={() =>
                                  updatePage(index, "mode", "product")
                                }
                                className="sr-only peer"
                              />
                              <div className="w-full flex gap-x-3 items-start p-4 cursor-pointer rounded-lg border bg-white shadow-sm ring-indigo-600 peer-checked:ring-2 duration-200">
                                <div className="flex-none">
                                  <img
                                    src="https://cdn-icons-png.flaticon.com/128/5692/5692284.png" // رابط الـ GIF
                                    style={{ width: "28px" }} // حجم صغير داخل الزر
                                    alt={t("ui.buttonIcon")}
                                  />
                                </div>
                                <div>
                                  <h3 className="leading-none text-gray-800 font-medium pr-3">
                                    {" "}
                                    {t(
                                      "servicePageActivation.foorchat.form.productMode",
                                    )}
                                  </h3>
                                  <p className="mt-1 text-sm text-gray-600">
                                    {t(
                                      "servicePageActivation.foorchat.form.productMode1",
                                    )}
                                  </p>
                                </div>
                              </div>
                              <div className="absolute top-4 left-4 flex-none flex items-center justify-center ww-4 hh-4 rounded-full border peer-checked:bg-indigo-600 text-white peer-checked:text-white duration-200">
                                <svg className="w-4 h-4" viewBox="0 0 12 10">
                                  <polyline
                                    fill="none"
                                    strokeWidth="2px"
                                    stroke="currentColor"
                                    strokeDasharray="16px"
                                    points="1.5 6 4.5 9 10.5 1"
                                  />
                                </svg>
                              </div>
                            </label>
                          </li>
                        </div>
                      </ul>
                    </div>
                    {/* ---------------------------------------------------------------------------------------------------------------- */}

                    {page.mode === "product" && (
                      <div className="mb-4">
                        <select
                          value={page.urlProduct}
                          onChange={(e) =>
                            updatePage(index, "urlProduct", e.target.value)
                          }
                          className="w-full border-2 border-gray-200 dark:!border-gray-600 rounded-lg p-3 focus:border-purple-500 focus:ring-2 focus:ring-purple-500 focus:ring-opacity-20 transition-all duration-200 bg-white dark:bg-gray-800 text-gray-800 dark:text-gray-200"
                        >
                          <option value="">
                            {t(
                              "servicePageActivation.foorchat.form.productPlaceholder",
                            )}
                          </option>
                          {products
                            ?.filter((product) => product.deleted !== 1)
                            .map((product) => {
                              const name = product.name || product.title || "";
                              const words = name.split(" ");
                              const shortName =
                                words.length > 8
                                  ? words.slice(0, 8).join(" ") + "..."
                                  : name;

                              return (
                                <option key={product.id} value={product.url}>
                                  {shortName}
                                </option>
                              );
                            })}
                        </select>
                      </div>
                    )}

                    <div className="flex items-center space-x-reverse space-x-2 text-sm text-gray-500 dark:text-gray-400 bg-blue-50 dark:bg-blue-900/30 px-4 py-2 rounded-lg">
                      <Calendar className="w-4 h-4 text-blue-500" />
                      <span>
                        {t("servicePageActivation.foorchat.form.expiresAt")}{" "}
                        {page.timeExpired?.seconds
                          ? new Date(
                              page.timeExpired.seconds * 1000,
                            ).toLocaleDateString("ar", {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                            })
                          : t("foorchat.link_pages.form.unknownDate")}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Submit Button */}
          <div className="flex justify-center">
            <button
              type="submit"
              disabled={loading || !hasStateChanged()}
              className={`group relative inline-flex items-center justify-center px-12 py-4 text-lg font-semibold rounded-2xl shadow-2xl transition-all duration-300 transform ${
                !hasStateChanged()
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed dark:bg-gray-700 dark:text-gray-400"
                  : "bg-gradient-to-r from-[#9e68ba] to-[#9e68ba] hover:from-[#8d5da7] hover:to-[#8d5da7] hover:scale-105 hover:shadow-[#9e68ba]/25 text-white"
              }`}
            >
              {loading ? (
                <>
                  <RefreshCw className="animate-spin w-5 h-5 ml-3" />
                  {t("servicePageActivation.foorchat.buttons.saving")}
                </>
              ) : !hasStateChanged() ? (
                <>
                  <Info className="w-5 h-5 ml-3" />
                  {t("servicePageActivation.foorchat.buttons.noChanges")}
                </>
              ) : (
                <>
                  <Check className="w-5 h-5 ml-3" />
                  {t("servicePageActivation.foorchat.buttons.saveSettings")}
                  {!loading && hasStateChanged() && (
                    <div className="absolute inset-0 bg-white/20 transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700 rounded-2xl"></div>
                  )}
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
